var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-1/2 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold mb-2 border-b border-black mb-3"
                  },
                  [_vm._v("Total Earning")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-4xl text-left text-black font-bold" },
                  [
                    _vm._v(
                      "$" + _vm._s(parseFloat(_vm.earningToDate).toFixed(2))
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-1/2 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold mb-2 border-b border-black mb-3"
                  },
                  [_vm._v("Balance")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-4xl text-left text-black font-bold" },
                  [
                    _vm._v(
                      "$" + _vm._s(parseFloat(_vm.artistBalance).toFixed(2))
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-full p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg"
            },
            [
              _c(
                "div",
                { staticClass: "m-3" },
                [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "text-xs text-left font-bold mb-2 border-b border-black mb-3"
                    },
                    [
                      _vm._v(
                        "Number Songs Sold " +
                          _vm._s(new Date().getFullYear()) +
                          "\n              "
                      ),
                      _c("span", {
                        staticClass: "text-xs text-teal-800 float-right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("highcharts", {
                    ref: "chart2",
                    staticClass: "hc2 h-300",
                    attrs: { options: _vm.soldSong }
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-full p-3 " }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg"
            },
            [
              _c(
                "div",
                { staticClass: "m-3" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("highcharts", {
                    ref: "chart",
                    staticClass: "hc",
                    class: "h-300",
                    attrs: { options: _vm.weeklyCustomer }
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-1/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "pb-3 card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold border-b border-black"
                  },
                  [_vm._v("Most Popular Song")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h-300 overflow-y-auto" }, [
                  _c(
                    "ul",
                    {
                      staticClass: "flex mb-0 list-none flex-wrap pb-4 flex-row"
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass:
                            "-mb-px flex-auto text-center cursor-pointer "
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                " text-xs uppercase px-5 py-3  block leading-normal text-black",
                              class: {
                                "": _vm.popularSongTabIndex !== 1,
                                "font-bold border-b border-black":
                                  _vm.popularSongTabIndex === 1
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTabPopularSong(1)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Lifetime\n                  "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass:
                            "-mb-px flex-auto text-center cursor-pointer "
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-xs uppercase px-5 py-3 block leading-normal text-black",
                              class: {
                                "": _vm.popularSongTabIndex !== 2,
                                "font-bold border-b border-black":
                                  _vm.popularSongTabIndex === 2
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTabPopularSong(2)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Active Year\n                  "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative flex flex-col min-w-0 break-words bg-white w-full mb-2"
                    },
                    [
                      _c("div", { staticClass: "flex-auto" }, [
                        _c("div", { staticClass: "tab-content tab-space" }, [
                          _c(
                            "div",
                            {
                              staticClass: "mx-400 overflow-y-auto",
                              class: {
                                hidden: _vm.popularSongTabIndex !== 1,
                                block: _vm.popularSongTabIndex === 1
                              }
                            },
                            [
                              _c(
                                "ol",
                                {
                                  staticClass: "list-outside pl-6",
                                  class:
                                    _vm.dataPopularSongLifetime.length > 0
                                      ? "list-decimal"
                                      : ""
                                },
                                [
                                  _vm.dataPopularSongLifetime.length === 0
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "text-center text-sm font-bold text-black p-3"
                                        },
                                        [_vm._v("No Data")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.dataPopularSongLifetime, function(
                                    song
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: song.id,
                                        staticClass:
                                          "text-left text-sm font-bold text-black mb-3"
                                      },
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(song.name)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-teal-800 float-right"
                                          },
                                          [_vm._v(_vm._s(song.total_purchase))]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mx-400 overflow-y-auto",
                              class: {
                                hidden: _vm.popularSongTabIndex !== 2,
                                block: _vm.popularSongTabIndex === 2
                              }
                            },
                            [
                              _c(
                                "ol",
                                {
                                  staticClass: "list-outside pl-6",
                                  class:
                                    _vm.dataPopularSongCurrent.length > 0
                                      ? "list-decimal"
                                      : ""
                                },
                                [
                                  _vm.dataPopularSongCurrent.length === 0
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "text-center text-sm font-bold text-black p-3"
                                        },
                                        [_vm._v("No Data")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.dataPopularSongCurrent, function(
                                    song
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: song.id,
                                        staticClass:
                                          "text-left text-sm font-bold text-black mb-3"
                                      },
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(song.name)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-teal-800 float-right"
                                          },
                                          [_vm._v(_vm._s(song.total_purchase))]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-1/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "pb-3 card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold border-b border-black"
                  },
                  [_vm._v("Most Popular Album")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h-300 overflow-y-auto" }, [
                  _c(
                    "ul",
                    {
                      staticClass: "flex mb-0 list-none flex-wrap pb-4 flex-row"
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass:
                            "-mb-px flex-auto text-center cursor-pointer "
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                " text-xs uppercase px-5 py-3  block leading-normal text-black",
                              class: {
                                "": _vm.popularAlbumTabIndex !== 1,
                                "font-bold border-b border-black":
                                  _vm.popularAlbumTabIndex === 1
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTabPopularAlbum(1)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Lifetime\n                  "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass:
                            "-mb-px flex-auto text-center cursor-pointer "
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-xs uppercase px-5 py-3 block leading-normal text-black",
                              class: {
                                "": _vm.popularAlbumTabIndex !== 2,
                                "font-bold border-b border-black":
                                  _vm.popularAlbumTabIndex === 2
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTabPopularAlbum(2)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Active year\n                  "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative flex flex-col min-w-0 break-words bg-white w-full mb-6"
                    },
                    [
                      _c("div", { staticClass: "flex-auto" }, [
                        _c("div", { staticClass: "tab-content tab-space" }, [
                          _c(
                            "div",
                            {
                              staticClass: "mx-400 overflow-y-auto",
                              class: {
                                hidden: _vm.popularAlbumTabIndex !== 1,
                                block: _vm.popularAlbumTabIndex === 1
                              }
                            },
                            [
                              _c(
                                "ol",
                                {
                                  staticClass: "list-outside pl-6",
                                  class:
                                    _vm.dataPopularAlbumLifetime.length > 0
                                      ? "list-decimal"
                                      : ""
                                },
                                [
                                  _vm.dataPopularAlbumLifetime.length === 0
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "text-center text-sm font-bold text-black p-3"
                                        },
                                        [_vm._v("No Data")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.dataPopularAlbumLifetime, function(
                                    song
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: song.id,
                                        staticClass:
                                          "text-left text-sm font-bold text-black mb-3"
                                      },
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(song.name)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-teal-800 float-right"
                                          },
                                          [_vm._v(_vm._s(song.total_purchase))]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mx-400 overflow-y-auto",
                              class: {
                                hidden: _vm.popularAlbumTabIndex !== 2,
                                block: _vm.popularAlbumTabIndex === 2
                              }
                            },
                            [
                              _c(
                                "ol",
                                {
                                  staticClass: "list-outside pl-6",
                                  class:
                                    _vm.dataPopularAlbumCurrent.length > 0
                                      ? "list-decimal"
                                      : ""
                                },
                                [
                                  _vm.dataPopularAlbumCurrent.length === 0
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "text-center text-sm font-bold text-black p-3"
                                        },
                                        [_vm._v("No Data")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.dataPopularAlbumCurrent, function(
                                    song
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: song.id,
                                        staticClass:
                                          "text-left text-sm font-bold text-black mb-3"
                                      },
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(song.name)
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-xs text-teal-800 float-right"
                                          },
                                          [_vm._v(_vm._s(song.total_purchase))]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-1/3 p-3" }, [
        _c("div", { staticClass: "mb-2 bg-white" }, [
          _c(
            "div",
            {
              staticClass:
                "card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200"
            },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "text-xs text-left font-bold mb-2 border-b border-black mb-3"
                  },
                  [_vm._v("Top Countries " + _vm._s(new Date().getFullYear()))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h-300 overflow-y-auto px-3" }, [
                  _c(
                    "ol",
                    {
                      staticClass: "list-outside pl-4",
                      class: _vm.dataTopCountry.length > 0 ? "list-decimal" : ""
                    },
                    [
                      _vm.dataTopCountry.length === 0
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "text-center text-sm font-bold text-black p-3"
                            },
                            [_vm._v("No Data")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.dataTopCountry, function(country) {
                        return _c(
                          "li",
                          {
                            key: country.country_code,
                            staticClass:
                              "text-left text-sm font-bold text-black mb-3"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(country.country_name)
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "text-xs text-teal-800 float-right"
                              },
                              [_vm._v(_vm._s(country.total))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h2",
      {
        staticClass:
          "text-xs text-left font-bold mb-2 border-b border-black mb-3"
      },
      [
        _vm._v("Weekly Customer\n              "),
        _c("span", { staticClass: "text-xs text-teal-800 float-right" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-248b2e36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-248b2e36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statistic/Artist.vue
// module id = null
// module chunks = 